import React, { useState, useEffect } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import axios from "axios"
import Loading from "./loading"
import PremiumServices from "../components/Sidebar/PremiumServices"
import Seo from "../components/seo"
import Button from '@material-ui/core/Button';
import {ShippingMainPage} from "./shipping"
import { ShippingTitle } from "./shipping"

const CoastalReportData = (props) => {
    return (
      <tr>
        <td>{props.Name}</td>
        <td>{props.Wind}</td>
        <td>{props.Gust}</td>
        <td>{props.Visibility}</td>
        <td>{props.Weather}</td>
        <td>{props.Pressure}</td>
        <td>{props.Tendency}</td>
      </tr>
    );
  }

export const CoastalReportsFullPage = () => {
  const [url, setUrl] = useState(process.env.MET_COASTALREPORTS)
  const [data, setData] = useState([])
  const [stationReportData, setStationReportData] = useState([])
  const [loading, setloading] = useState(true);
  const [error, setError] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setloading(true)
      try {
        const result = await axios(url)
        setData(result.data)
        setStationReportData(result.data.StationReport)
      } catch (error) {
        setError(true)
        console.log(error)
      }
      setloading(false)
    }
    fetchData()
  }, [url])

  return (
    <React.Fragment>
            {error ? (
              <React.Fragment>
              <div>
                <p style={{ color: "#bf0d0d" }}>
                  Coastal report data unavailable
                </p>
              </div>
              <div style={{textAlign:"center"}}><Button className="resendButton" onClick={() => setUrl(process.env.MET_COASTALREPORTS) }>Try again</Button></div>
              </React.Fragment>
            ) : loading ? (
              <Loading />
            ) : (
              <React.Fragment>
                        <div className="Content">

                <div style={{ overflowX: "auto" }}>
                  <h2 style={{marginTop:"0"}}>
                    {data.Time} {data.Title} {data.Date}
                  </h2>
                  <table className="generalTableStyle">
                    <thead>
                      <tr>
                        <th>Station</th>
                        <th>Wind</th>
                        <th>Gust</th>
                        <th>Visibility</th>
                        <th>Weather</th>
                        <th>Pressure</th>
                        <th>Tend</th>
                      </tr>
                    </thead>
                    <tbody>
                    {stationReportData.map(result => <CoastalReportData key={result.Id} {...result} />)}
                    </tbody>
                  </table>
                  <h3>Key</h3>
                  <table className="generalTableStyle">
                    <tbody>
                      <tr>
                        <td>Gusts are in knots</td>
                        <td>R=rising</td>
                        <td>S=slowly</td>
                      </tr>
                      <tr>
                        <td> &lt; = less than</td>
                        <td>F = falling</td>
                        <td>Q = quickly</td>
                      </tr>
                      <tr>
                        <td>NM = nautical miles</td>
                        <td>S = steady</td>
                        <td>VR = very rapidly</td>
                      </tr>
                      <tr>
                        <td>m = metres</td>
                        <td>N/A = not available</td>
                        <td>Auto = automatic station</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </React.Fragment>
              )}
    </React.Fragment>
  )
}

export const CoastalReportHeading = () => {
  return (
    <>
    <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
        <h1>
        Coastal reports
        </h1>                  
    </Grid></>
  )
}


const CoastalReports = () => {
  
  return (
    <React.Fragment>
      <Layout>
        <Seo title="Channel Islands coastal weather reports" description="Weather reports from coastal stations in the English Channel" />
        <div className="forecastAutoMargin">
        <CoastalReportHeading/>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
            <CoastalReportsFullPage/>
            <div style={{marginTop:"20px"}}>
                <p>&nbsp;</p>
              <ShippingTitle/>
              <p />
              <ShippingMainPage/>
            </div>
            </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                <PremiumServices/>
                </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default CoastalReports


